<template>
	<div>
		<div v-if="!isDetail">
			<template v-if="tabConditions.Discount">
				<div class="layout__item u-8/24-default u-1/1-palm pl0">
					<h6>{{tabConditions.Discount.Text}}</h6>
				</div>
				<div
					class="layout__item u-16/24-default u-1/1-palm u-text--bold pb-- zeta"
				>{{tabConditions.Discount.Unit}}{{tabConditions.Discount ? tabConditions.Discount.Value : ''}}</div>
			</template>
			<div
				class="layout__item u-1/1 pl0"
			>{{tabConditions.DiscountText ? tabConditions.DiscountText.Value : ''}}</div>

			<div class="layout__item u-8/24-default u-1/1-palm pl0 mt">
				<h6>{{tabConditions.NoticePeriod.Text}}</h6>
			</div>
			<div class="layout__item u-16/24-default u-1/1-palm u-text--bold pb-- mt zeta">
				{{tabConditions.NoticePeriod ? tabConditions.NoticePeriod.Value :''}}
				{{tabConditions.NoticePeriod ? tabConditions.NoticePeriod.Unit :''}}
			</div>
			<div
				class="layout__item u-1/1 pl0"
			>{{tabConditions.NoticePeriodText ? tabConditions.NoticePeriodText.Value : ''}}</div>
		</div>
		<template v-else>
			<p v-if="properties.Action">
				<b>Actie via deze website:</b>
				<span
					class="u-text-color-status--green u-display--inline-block default-ml"
					v-html="properties.Action"
				></span>

				<span v-if="resultItem.ActionExplanation">
					<br />
					{{resultItem.ActionExplanation}}
				</span>
			</p>

			<template v-for="(prop, index) in properties.Contract">
				<text-value-label :data="prop" :key="index" />
			</template>
			<template v-for="(prop, index) in properties.Attachments">
				<text-value-label :data="prop" :key="`${prop}${index}`" />
			</template>
			<template v-if="isDetail">
				<toggle-details>
					<template slot="header">Ingang van dit contract</template>
					<template slot="content">
						<p
							v-if="properties.EntryOfContract"
							v-html="properties.EntryOfContract.replace(/\r\n/g, '<br />')"
						></p>
					</template>
				</toggle-details>

				<template v-for="featureCat in properties.PackageFeatureCategories">
					<toggle-details :key="featureCat.Name">
						<template slot="header">{{featureCat.Name}}</template>
						<template slot="content">
							<text-value-label v-for="feat in featureCat.Features" :key="feat.Text" :data="feat" />
						</template>
					</toggle-details>
				</template>
				<toggle-details :key="'Einde contract'">
					<template slot="header">Einde contract</template>
					<template slot="content">
						<text-value-label v-for="feat in properties.ContractEnd" :key="feat.Text" :data="feat" />
					</template>
				</toggle-details>
			</template>
		</template>
	</div>
</template>

<script>
import ToggleDetails from './ToggleDetails';
import TextValueLabel from './TextValueLabel';

export default {
	components: { TextValueLabel, ToggleDetails },
	props: {
		resultItemBaseData: {
			type: Object,
			default: () => {}
		},
		isDetail: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		resultItem: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		tabConditions() {
			return this.resultItemBaseData.ComparisonTabs
				.ComparisonTabConditions;
		},
		properties() {
			return this.resultItem.Properties;
		}
	}
};
</script>

<style>
</style>
